import { useMemo } from 'react';

import Icon from 'components/global/Icon';
import Typography from 'components/global/Typography';

import { faBuilding, faCabinetFiling, faPersonCarryBox, faTruckFlatbed } from '@fortawesome/pro-regular-svg-icons';

import * as S from './styled/PickupAndDeliveryType.styled';

export const PickupAndDeliveryTypes = {
	PICKUP_BY_CUSTOMER: { icon: faPersonCarryBox, text: 'PICKUP_BY_CUSTOMER' },
	TO_CUSTOMER_DOORSTEP: { icon: faBuilding, text: 'TO_CUSTOMER_DOORSTEP' },
	LOCKER: { icon: faCabinetFiling, text: 'LOCKER' },
	LOCKER_DROP_OFF: { icon: faCabinetFiling, text: 'LOCKER_DROP_OFF' },
	DELIVERED_TO_DC_WAREHOUSE: { icon: faPersonCarryBox, text: 'DELIVERED_TO_DC_WAREHOUSE' },
	PICKUP_BY_DC: { icon: faTruckFlatbed, text: 'PICKUP_BY_DC' },
	BRANCH_DROP_OFF: { icon: faPersonCarryBox, text: 'BRANCH_DROP_OFF' },
	pickupFromStore: { icon: faBuilding, text: 'pickupFromStore' }
};

const PickupAndDeliveryType = ({ value }) => {
	const data = useMemo(() => PickupAndDeliveryTypes[value], [value]);

	return (
		data && (
			<S.PickupAndDeliveryTypeWrapper>
				<Icon icon={data.icon} />
				<Typography>{data.text}</Typography>
			</S.PickupAndDeliveryTypeWrapper>
		)
	);
};

export default PickupAndDeliveryType;
